module.exports = __webpack_public_path__ + "static/media/image_8.0c8c3267.jpg";